module.exports = __webpack_public_path__ + "img/join-background-4.556416de.png";